import { useQuery } from '@tanstack/react-query';

import YoutubeApi from '../../services/YoutubeApi';

const getVideoDuration = async (embedId: string) => {
    const data = await YoutubeApi.getVideoDetails(embedId);

    return data.items?.[0]?.contentDetails.duration
        .replace('PT', '')
        .replace('M', ':')
        .replace('S', '');
};

export default function useGetVideoDuration(embedId: string) {
    return useQuery({
        queryKey: ['video-duration'],
        queryFn: () => getVideoDuration(embedId),
    });
}
